<template><!--左侧菜单项-->
  <el-aside :width="isCollapse?'64px':'200px'">
    <!--          收起导航栏-->
    <div style="background: #B3C0D1;text-align: center;font-size: 14px;height: 50px;line-height: 50px;" >{{xtname||'-'}}</div>
    <!-- default-active当前激活菜单的 index
    background-color="#20222B"
      text-color="#BDBDC0"
      active-text-color="#ffd04b"
    -->
    <el-menu
      :default-active="activePath"
      class="el-menu-vertical-demo"
      background-color="rgb(238, 241, 246)"
      :unique-opened="true"
      :router="false"
      :collapse="isCollapse"
      :collapse-transition="false"
    >
      <!--一级导航-->
      <template v-for="item in navData">

        <!--有子集-->
        <el-submenu :index="item.id" v-if="item.navChildren.length>0">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{item.title}}</span>
          </template>
          <!--二级导航-->
          <el-menu-item :index="item2.path" v-for="item2 in item.navChildren" :key="item2.id"
                        @click="addTab(item2)">
            <i class="el-icon-menu"></i>
            <span slot="title">{{item2.title}}</span>
          </el-menu-item>
        </el-submenu>

        <!--无子集-->
        <el-menu-item v-else :index="item.path" @click="addTab(item)">
          <i :class="item.icon"></i>
          <span slot="title">{{item.title}}</span>
        </el-menu-item>
      </template>

    </el-menu>


  </el-aside>

</template>

<script>
import {mapGetters,mapState} from 'vuex'
// import tabsValue from "../store/tabsValue";

export default {
  name: "NavItem",
  props:['isCollapse','xtname'],
  data() {
    return {
      menuList: [],
      // activePath: '',
      // isCollapse: false//是否水平折叠收起菜单（仅在 mode 为 vertical 时可用）
    }
  },
  computed: {
    ...mapGetters({navData: 'navData'}),
    ...mapState({activePath:state=>state.tabsValue.activePath})
  },
  methods: {
    async getMenuList() {
      const res = await this.$api.sys.leftMenus();
      // console.log(res);
      if (res.code == 1) {
        return this.$message.error("获取菜单失败")
      }
      this.menuList = res.data;
    },
    //点击二级菜单激活index值

    addTab(data){
      // console.log('addTab',data)
      this.$store.dispatch('ADD_TAB',data)
    }
  },
  mounted() {
    this.getMenuList();

  }
}
</script>

<style scoped>
.el-menu-item.is-active {
  background-color: #c8e1fd !important;
}
.el-aside {
  /*background: rgb(32, 34, 43);*/
  background: rgb(238, 241, 246);
}
.el-menu{
  border-right: none;
}
/deep/ .el-submenu__title,.el-menu-item{
  font-size: 12px;
}

/**垂直滚动条样式 *
宽度 */
::-webkit-scrollbar {
  width: 2px;
}
/* 背景色 */
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}
/**滑块颜色 */
::-webkit-scrollbar-thumb {background-color: #c1c1c1;}
/*水平滚动条样式 */
/* 高度 */
::-webkit-scrollbar {
  height: 2px;
}
</style>



// WEBPACK FOOTER //
// src/views/NavItem.vue